@import '~style-sheet-helpers/core';
@import '../../../../app-brand/entities/entity-layer.module.less';

.dragging {
  background: @hooks-display-grid--header-cell--dragging--background-color;
  box-shadow: 0 0 4px @hooks-display-grid--header-cell--dragging--box-shadow-color;
}

.non-sortable {
  cursor: grab;
  -webkit-cursor: grab;
}

.header-name {
  .truncate();
  line-height: 30px;
}

.header-icon {
  height: 30px;
  width: 30px;
  margin-right: -16px;

  > svg {
    width: 14px;
    color: @hooks-display-grid--header-cell--icon-color;
  }
}

.header-cell-resize-gripper {
  position: absolute;
  top: 0;
  right: -10px;
  width: 20px;
  height: 30px;
  cursor: col-resize;
  z-index: 2;
}
